export default __webpack_public_path__ + "static/media/sounds/ran_numbers_practice_instruction_start_alyx.mp3";